/**
 * Copy `text` to the system clipboard. Uses the async Clipboard API when
 * available; falls back to a transient `<textarea>` + `document.execCommand`
 * for older browsers.
 *
 * Centralised here so tests can vi.mock this module — jsdom's
 * `navigator.clipboard` is exposed as a non-writable getter and can't be
 * reliably spied on directly.
 */
export async function copyToClipboard(text: string): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
  } finally {
    document.body.removeChild(ta);
  }
}
